<template>
    <SoliText
        ref="phone"
        v-model="input"
        :disabled="disabled"
        :label="label ?? 'Phone'"
        :errors="errors"
        :rules="optional ? rules.phoneOptional : rules.phone"
        :hide-details="hideDetails"
        validateOnBlur
        phone
        icon="phone"
        placeholder="10-digits"
    ></SoliText>
</template>

<script>
import SoliForm from './SoliForm.vue';

export default {
    props: {
        errors: {},
        value: {},
        label: {},
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        optional: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            rules: SoliForm.formRules,
        };
    },
    methods: {
        limitDigits(event) {
            if (event.metaKey || event.ctrlKey || event.key.length > 1) return;
            if (event.key < '0' || event.key > '9') {
                event.preventDefault();
                return;
            }
            const current = (this.value || '').replace(/\D/g, '');
            if (current.length >= 10) {
                event.preventDefault();
            }
        },
        handlePaste(event) {
            event.preventDefault();
            const paste = (event.clipboardData || window.clipboardData).getData('text');
            const formatted = this.maskPhone(paste);
            const input = this.$refs.phone.$refs.input.$refs.input;
            if (input) input.value = formatted || '';
            this.$emit('input', formatted);
        },
        maskPhone(value) {
            if (!value) return;

            let digits = value.replace(/\D/g, '');

            if (digits.length >= 11 && digits[0] === '1') {
                digits = digits.substring(1);
            }

            digits = digits.substring(0, 10);

            let x = digits.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

            return !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
    },
    mounted() {
        this.maskPhone(this.value);
        const input = this.$refs.phone.$refs.input.$refs.input;
        if (input) {
            input.addEventListener('keypress', this.limitDigits);
            input.addEventListener('paste', this.handlePaste);
        }
    },
    beforeDestroy() {
        const input = this.$refs.phone?.$refs.input?.$refs.input;
        if (input) {
            input.removeEventListener('keypress', this.limitDigits);
            input.removeEventListener('paste', this.handlePaste);
        }
    },
    computed: {
        input: {
            get() {
                return this.maskPhone(this.value);
            },
            set(value) {
                const formatted = this.maskPhone(value);
                if (formatted?.length == 12) this.$refs.phone.$refs.input.validate();
                this.$emit('input', formatted);
            },
        },
    },
};
</script>
